exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".err-block {\n  border: 1px solid #ddd;\n  padding: 6px; }\n\n.hilite {\n  color: #60b515;\n  font-weight: bold; }\n\n.discr {\n  color: #c92100;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/live-header/header-table-gen/header-table-gen.component.scss
// module id = ../../../../../src/app/views/daily-recon/live-header/header-table-gen/header-table-gen.component.scss
// module chunks = main